import { default as styled } from "styled-components";

export const QueryBarContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1050;
    margin-left: 13px;
    gap: 16px;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const CategoryItemWrapper = styled.div`
    display: flex;
    max-width: 320px;
    min-width: 128px;
    flex-shrink: 1;
    line-height: normal;
`;

export const CategorySearchContainer = styled.div`
    position: absolute;
    width: 620px;
    z-index: 100;
    top: 0;

    .input-container {
        height: 43px;
    }
`;
